import { RATING_THRESHOLDS } from './constants'
import type { RatingEnvironment } from './types'

/** Umbral mínimo de valoraciones para mostrar puntuación en el entorno dado
 * (spec.md FR-009/FR-017): 1 en local/development, 5 en preproduction/production. */
export function getRatingThreshold(environment: RatingEnvironment): number {
  return RATING_THRESHOLDS[environment]
}
